import React from 'react'
import {isEmpty} from 'lodash'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import EditFormula from './EditFormula'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'
import FormulaNotFound from './FormulaNotFound'

import Resource from '../../stores/resource'
const FormulaStore = Resource('formulas')

class EditFormulaPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      formula: {},
      error: '',
      loading: true
    }
  }

  componentDidMount() {
    FormulaStore.find(this.props.match.params.id)
    .then((result) => this.setState({formula: result.data, loading: false}))
    .catch((error) => this.setState({formula: {}, error: errors.unpack(error), loading: false}))
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    const {
      error,
      loading,
      formula
    } = this.state

    if (loading) return <LinearLoader />
    if (isEmpty(formula)) return <FormulaNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Edit formula
          </PageTitle>
        </header>

        <EditFormula formula={formula} />
        <br/>
        <BackButton/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }

}

export default EditFormulaPage



// WEBPACK FOOTER //
// ./src/components/Formulas/EditFormulaPage.jsx